module.exports = __webpack_public_path__ + "img/ic_16_moderator.79fe0e3a.svg";